import React from 'react'
import PropTypes from 'prop-types'
import { Button, Box, Copy, Icon } from '@elparking/components'
import { Container, StyledBox } from '../ui'
import { FormattedMessage } from 'react-intl'

const Success = ({ onBack, message, buttonMessage }) => (
    <Container key='error'>
        <StyledBox justifyContent='center'>
            <Box textAlign='center' width='100px' height='100px' p='2em' background='success'>
                <Icon type='ok' color='white' size='xxxLarge' />
            </Box>
        </StyledBox>
        <Copy padding='2em' textAlign='center' fontColor='gray' fontSize='xSmall' fontWeight='regular' transform='uppercase'>
            {message}
        </Copy>
        <Button width='100%' onClick={onBack}>
            <Icon type='left' color='white' /> {buttonMessage}
        </Button>
    </Container>
)

Success.propTypes = {
    onBack: PropTypes.func.isRequired,
    message: PropTypes.node.isRequired,
    buttonMessage: PropTypes.node,
}

Success.defaultProps = {
    buttonMessage: <FormattedMessage defaultMessage='Ver detalles' />,
}

export default Success
